// src/hooks/useBrowserCheck.js
import { useEffect, useState } from 'react';

const useBrowserCheck = () => {
    const [isAllowedBrowser, setIsAllowedBrowser] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        const isChrome = /Chrome/.test(userAgent) && !/Edg/.test(userAgent);
        const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
        const isFirefox = /Firefox/.test(userAgent);
        const isEdge = /Edg/.test(userAgent);

        const isInAppBrowser = /Instagram|FB_IAB|FBAN|Twitter|LinkedIn|Line|Snapchat|WhatsApp/.test(userAgent);

        if ((isChrome || isSafari || isFirefox || isEdge) && !isInAppBrowser) {
            setIsAllowedBrowser(true);
        } else {
            setIsAllowedBrowser(false);
        }
    }, []);

    return isAllowedBrowser;
};

export default useBrowserCheck;
